module.exports = __webpack_public_path__ + "static/fipcwhiteabc2-c0f487035eb5e5841375046e6f39a5c4.jpeg";